import { render, staticRenderFns } from "./EventBannerForm.vue?vue&type=template&id=f5dade4e&scoped=true&"
import script from "./EventBannerForm.vue?vue&type=script&lang=js&"
export * from "./EventBannerForm.vue?vue&type=script&lang=js&"
import style0 from "./EventBannerForm.vue?vue&type=style&index=0&id=f5dade4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dade4e",
  null
  
)

export default component.exports